import React from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';

import Message from './Message';

class MessageContainer extends React.Component {
    componentDidMount() {
        this.scrollToBottom('instant');
    }

    componentDidUpdate() {
        if (this.props.scrollToBottom) {
            this.scrollToBottom('instant', true);
        }
    }

    scrollToBottom(behavior, resetReduxScrollFlag) {
        this.messagesEnd?.scrollIntoView({ behavior }); //eslint-disable-line
        if (resetReduxScrollFlag) {
            this.props.scrolledToBottom();
        }
    }

    render() {
        const { messages, peoplesDict, loading, lastRead, currentUserId, 'data-testid': dataTestId } = this.props;

        function renderMessages() {
            let dateGroup;
            let idx;
            const messageTitleDates = [];
            const messagesByDate = [];

            messages.forEach(msg => {
                dateGroup = moment.utc(msg.created).local().format('YYYY-MM-DD');
                idx = messageTitleDates.indexOf(dateGroup);
                if (idx === -1) {
                    messageTitleDates.push(dateGroup);
                    messagesByDate[messageTitleDates.length - 1] = [msg];
                } else {
                    messagesByDate[idx].push(msg);
                }
            });

            function renderDate(date) {
                const today = moment(new Date()).format('YYYY-MM-DD');
                return date === today ? 'Today' : moment(date).format('ddd, MMM DD');
            }

            function isNewMessage(massageDate) {
                return moment(massageDate).isAfter(lastRead);
            }

            return messagesByDate.map((date, i) => {
                return (
                    <React.Fragment key={`${renderDate(messageTitleDates[i])}`}>
                        {date.map((msg) => {
                            const sender = peoplesDict[msg.senderId];
                            const isCurrentUser = currentUserId && parseInt(sender?.entityId) === parseInt(currentUserId);
                            const profileLink = !isCurrentUser && sender?.playerId ? `/profiles/${sender.playerId}` : null;

                            return (
                                <Message
                                    id={msg.id}
                                    type="message"
                                    key={msg.id}
                                    playerProfileImages={sender?.playerProfileImages}
                                    name={`${sender?.firstName} ${sender?.lastName}`}
                                    message={msg.fallback}
                                    timestamp={msg.created}
                                    hasNewMessage={isNewMessage(msg.created)}
                                    profileLink={profileLink}
                                    data-testid={dataTestId ? `${dataTestId}.msg-${msg.id}` : undefined}
                                />
                            );
                        })}
                        <div className="date-div-line" data-testid={dataTestId ? `${dataTestId}.date-${messageTitleDates[i]}` : undefined}>
                            <div className="date-div text-uppercase">{renderDate(messageTitleDates[i])}</div>
                        </div>
                    </React.Fragment>
                );
            });
        }

        return (
            <Scrollbars
                style={{ height: '100%' }}
                universal
            >
                <div className="message-inner-container">
                    <div
                        style={{ float: 'left', clear: 'both' }}
                        ref={(el) => { this.messagesEnd = el; }}
                    />
                    {renderMessages()}
                    {loading && (
                        <div className="text-center">
                            <p className="text-medium"><i className="fas fa-circle-notch fa-spin" /></p>
                        </div>
                    )}
                </div>
            </Scrollbars>
        );
    }
}

function mapStateToProps({ auth }) {
    return {
        currentUserId: auth?.user?.id,
    };
}

export default connect(mapStateToProps)(MessageContainer);
